import type { Action, Court, Tournament } from '../../types.js';
import { nextId } from '../../ids.js';
import { EngineError } from '../state.js';
import { uebernehmen } from './shared.js';

/** Felder (docs/17): anlegen, ändern, löschen */

const FELD_FELDER = ['name', 'group', 'active', 'priority'] as const;

export function applyCourt(t: Tournament, action: Action): string[] {
  const warnings: string[] = [];
  switch (action.type) {
    case 'court.add':
      t.courts.push({ id: nextId(t, 'c'), name: action.name, active: true, priority: action.priority ?? 0, ...(action.group ? { group: action.group } : {}) });
      break;
    case 'court.update': {
      const court = t.courts.find((c) => c.id === action.courtId);
      if (!court) throw new EngineError('Feld nicht gefunden');
      if (action.patch.active === false && court.currentMatchId) throw new EngineError('Feld ist belegt — erst Spiel beenden');
      // feldweise wie bei den anderen Änderungen — `Object.assign` hätte auch `id` oder `currentMatchId` überschrieben
      uebernehmen(court, action.patch, FELD_FELDER);
      break;
    }
    case 'court.remove': {
      const idx = t.courts.findIndex((c) => c.id === action.courtId);
      if (idx < 0) throw new EngineError('Feld nicht gefunden');
      const court = t.courts[idx] as Court;
      if (court.currentMatchId) throw new EngineError('Feld ist belegt — erst Spiel beenden');
      // Ein Feld, auf dem schon gespielt wurde, bleibt stehen: sonst zeigten die
      // Spiele im Protokoll auf ein Feld, das es nicht mehr gibt. Abschalten
      // reicht — es bekommt dann keine Spiele mehr.
      const used = t.competitions.some((comp) => comp.phases.some((p) => p.matches.some((m) => m.courtId === action.courtId)));
      if (used) throw new EngineError('Feld ist schon einem Spiel zugeteilt — statt löschen auf inaktiv setzen');
      t.courts.splice(idx, 1);
      break;
    }
  }
  return warnings;
}
